document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.pit-section').forEach(function (section) {
    var tabs = section.querySelectorAll('.pit-tab');
    var panels = section.querySelectorAll('.pit-panel');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-tab');

        tabs.forEach(function (t) {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('active');
        tab.setAttribute('aria-selected', 'true');

        panels.forEach(function (panel) {
          if (panel.getAttribute('data-panel') === target) {
            panel.classList.add('active');
          } else {
            panel.classList.remove('active');
          }
        });
      });
    });

    panels.forEach(function (panel) {
      var content = panel.querySelector('[data-content]');
      var fade = panel.querySelector('[data-fade]');
      var btn = panel.querySelector('[data-readmore]');
      var labelMore = btn ? btn.querySelector('[data-label-more]') : null;
      var labelLess = btn ? btn.querySelector('[data-label-less]') : null;

      if (!content || !btn) return;

      function checkOverflow() {
        var isOverflowing = content.scrollHeight > content.clientHeight + 2;
        if (!isOverflowing && !content.classList.contains('expanded')) {
          btn.classList.add('hidden');
          if (fade) fade.classList.add('hidden');
        } else {
          btn.classList.remove('hidden');
        }
      }

      checkOverflow();
      window.addEventListener('resize', checkOverflow);

      btn.addEventListener('click', function () {
        var expanded = content.classList.toggle('expanded');
        if (expanded) {
          if (fade) fade.classList.add('hidden');
          if (labelMore) labelMore.style.display = 'none';
          if (labelLess) labelLess.style.display = 'inline';
        } else {
          if (fade) fade.classList.remove('hidden');
          if (labelMore) labelMore.style.display = 'inline';
          if (labelLess) labelLess.style.display = 'none';
          checkOverflow();
        }
      });
    });
  });
});
